module.exports = __webpack_public_path__ + "static/media/piattos-cheese.f2fc711d.png";